import { BadgeColorAndNumber, Process, processStatuses } from '../../../types';

export const getBadgeColorAndNumber = (
  notReadImports: Process[]
): BadgeColorAndNumber => {
  const failedImports = notReadImports.filter(
    ({ status }) => status === processStatuses.failed
  );
  if (failedImports.length)
    return {
      color: 'error',
      number: failedImports.length,
    };

  const processingImports = notReadImports.filter(
    ({ status }) => status === processStatuses.processing
  );
  if (processingImports.length)
    return {
      color: 'primary',
      number: processingImports.length,
    };

  const finishedImports = notReadImports.filter(
    ({ status }) => status === processStatuses.finished
  );
  if (finishedImports.length)
    return {
      color: 'success',
      number: finishedImports.length,
    };

  return { color: 'default', number: 0 };
};
